module.exports = __webpack_public_path__ + "static/media/bfm-zdjęcie.38925119.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/home/img/bfm-zdjęcie.jpg
// module id = 589
// module chunks = 0